import React, { useContext, useCallback, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Image, Segment, Icon } from 'semantic-ui-react';
import { Flex, Box } from '@chakra-ui/core';
import { I18nTranslateContext, I18nLanguageContext } from './I18nContext';
import { firebaseApp } from './firebase-app';
import { useColors } from './hooks/useColors';

export const Logo = () => {
  const t = useContext(I18nTranslateContext);

  const { color } = useColors();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const pages = ['home', 'login', 'lobby', 'game', 'friendlist'];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % pages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev - 1 + pages.length) % pages.length);
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % pages.length);
  };

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const platform = isMobile ? 'mobile' : 'desktop';
  const currentImage = `/tixid-v2-${platform}-${pages[currentImageIndex]}.png`;

  return (
    <Box color={color}>
      <Link to="/">
        <Image src="/tixid.png" centered style={{ padding: '20px' }} alt="Tixid Online" />
      </Link>
      <Flex justifyContent="center" marginBottom={5}>
        <Segment
          inverted
          color="teal"
          textAlign="center"
          style={{
            padding: '15px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            borderRadius: '8px',
            width: '100%',
            maxWidth: '700px',
          }}
        >
          <div style={{ position: 'relative', width: '100%', margin: '0 auto' }}>
            <a
              href="https://v2.play-tixid.online"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#FFD700',
                textAlign: 'center',
                marginBottom: '20px',
                fontSize: '1.8rem',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              }}
            >
              🎮 Tixid V2 Beta is now LIVE ! 🎮
            </a>
          </div>
        </Segment>
      </Flex>
    </Box>
  );
};
